import * as React from 'react';
import { createRoot, Root } from 'react-dom/client';
import { Provider } from 'react-redux';
import { Store } from 'redux';
import { QualificationDialogHOC } from '../dialogs/qualification/hocs/QualificationDialogHOC/QualificationDialogHOC';

export class QualificationDialogReactToBackbone {
    el: Element;
    root: Root;
    store: Store;

    constructor (store: Store) {
        this.store = store;
        if (this.el) this.remove();
        this.el = document.createElement('div');
        this.el.className = 'qualification-dialog-placeholder';
        document.body.append(this.el);
        this.root = createRoot(this.el!);
        this.render();
    }

    render () {
        this.root.render(
            <Provider store={this.store}>
                <QualificationDialogHOC />
            </Provider>
        );
    }

    remove () {
        if (!this.el) return;

        this.root.unmount();
        this.el.remove();
        this.el = null;
    }
}
